module.exports = __webpack_public_path__ + "img/yaq_banner.5dbf2772.png";